<!-- 配件返厂 -->
<template>
  <div>
    <div class="detail-wrap">
      <el-form ref="editForm" :model="tenant">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info"/>
            <!-- {{ dataId ? '查看' : '新增' }}工单 -->
            工单号：<span v-if="formData.settleNo"
                         style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.settleNo }}</span>
            <span v-else class="information"> 待生成</span>

            <!-- 工单状态 -->
            <span v-if="!dataId" class="information"> 申请</span>
            <span v-else-if="formData.stat==0" class="information">未提交</span>
            <span v-else-if="formData.stat==1" class="information">提交未审核</span>
            <span v-else-if="formData.stat==5" class="information">已审核</span>
            <span v-else-if="formData.stat==9" class="information">驳回</span>
            <span v-else-if="formData.stat==19" class="information">已结算</span>
            <span v-else-if="formData.stat==99" class="information">取消</span>


          </div>
          <div style="">
            <el-button v-if="suspensionSettlement" type="primary" plain class="button-sty" @click="cancelSettle"
                       icon="el-icon-chat-line-square">
              中止结算
            </el-button>
          </div>
        </div>

        <div>
          <!-- 基本信息 -->
          <dix style="  overflow: unset!important;
    overflow-y: scroll!important;
    height: 100vh!important; ">
            <div class="d-cont edit-mce-box" >
              <div class="d-item">
                <div class="title first"><b>业务信息</b></div>
                <table class="table-detail">
                  <tbody>

                  <tr>
                    <th>机构名称</th>
                    <td>{{ formData.orgName }}</td>

                    <th>网点</th>
                    <td>{{ formData.siteName }}</td>
                  </tr>
                  <tr>
                    <th>结算归类属性</th>
                    <td v-if="formData.settleType==1">安装</td>
                    <td v-else-if="formData.settleType==2">维修</td>
                    <td v-else-if="formData.settleType==29">其他</td>
                    <td v-else></td>

                    <th>品牌名称</th>
                    <td>{{ formData.brandName }}</td>

                    <th>工单数量</th>
                    <td>{{ formData.orderQty }}</td>

                    <th>机器数量</th>
                    <td>{{ formData.machineQty }}</td>
                  </tr>
                  <tr>
                    <th>服务费</th>
                    <td>{{ formData.siteAmount }}</td>
                    <th>奖罚金额</th>
                    <td>{{ formData.rewardAmount }}</td>
                    <th>远程费</th>
                    <td>{{ formData.longDistanceAmount }}</td>
                    <th>特设费用</th>
                    <td>{{ formData.specialAmount }}</td>
                  </tr>
                  <tr>
                    <th>业务总金额</th>
                    <td>{{ formData.siteFinalAmount }}</td>
                  </tr>


                  <tr>
                    <th>本单调整金额</th>
                    <td>{{ formData.adjustMount }}</td>

                    <th>本单调整原因</th>
                    <td>{{ formData.adjustReason }}</td>
                    <th>总金额</th>
                    <td>{{ formData.amount }}</td>

                  </tr>

                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first"><b>业务金额</b></div>
                <div>
                  <!-- <div class="title first"><b>历史工单</b></div> -->
                  <vxe-table :stripe="true"
                             style="width: 60%;margin: 5px ;"
                             :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '45%' }"
                             :row-config="{height: 30,isHover: true,padding: 0,}"
                             :row-style="{ fontSize: '12px',  }"
                             show-overflow height="160"
                             :column-config="{ resizable: true }"
                             :data="formData.sfSettleFeeAttributeDTOList">
                    <vxe-column field="feeAttributeName" title="费用名称"></vxe-column>
                    <vxe-column field="amount" title="金额"></vxe-column>
                  </vxe-table>
                </div>
              </div>
              <div class="d-item">
                <div class="title first"><b>发票信息</b></div>
                <table class="table-detail">
                  <tbody>

                  <tr>
                    <th>税率</th>
                    <td>{{ formData.taxRate }}</td>
                    <th>税额</th>
                    <td>{{ formData.taxAmount }}</td>
                    <th>开票状态</th>
                    <td>{{ formData.invoiceStat }}</td>
                    <th>开票时间</th>
                    <td>{{ formData.invoiceNoDate }}</td>
                  </tr>
                  <tr>
                    <th>发票号</th>
                    <td>{{ formData.invoiceNo }}</td>
                    <th>发票金额</th>
                    <td>{{ formData.invoiceNoAmount }}</td>
                  </tr>


                  </tbody>
                </table>
              </div>

              <!-- 业务信息 -->
              <div class="d-item">
                <div class="title first"><b>付款信息</b></div>
                <table class="table-detail">
                  <tbody>

                  <tr>
                    <th>付款方式</th>
                    <td v-if="formData.payType==1">银行汇款</td>
                    <td v-else-if="formData.payType==2">转货款</td>
                    <td v-else-if="formData.payType==3">转配件款</td>
                    <td v-else></td>

                    <th>转货款金额</th>
                    <td>{{ formData.zhkAmount }}</td>
                    <th>转配件款金额</th>
                    <td>{{ formData.zpjAmount }}</td>
                    <th>其他金额</th>
                    <td>{{ formData.qtAmount }}</td>
                  </tr>
                  <tr>


                    <th>付现金额</th>
                    <td>{{ formData.realpayAmount }}</td>

                    <th>银行名称</th>
                    <td>{{ formData.bankName }}</td>

                    <th>银行帐号</th>
                    <td>{{ formData.bankAccount }}</td>
                    <th>银行帐户</th>
                    <td>{{ formData.bankAccountName }}</td>
                  </tr>


                  </tbody>
                </table>
              </div>

              <div class="d-item">
                <div class="title first"><b>其他信息</b></div>
                <table class="table-detail">
                  <tbody>

                  <tr>
                    <th>
                      审核时间
                    </th>
                    <td>{{ formData.checkDate }}</td>


                    <th>
                      结算时间
                    </th>
                    <td>
                      {{ formData.payDate }}
                    </td>
                    <th>
                      结算备注
                    </th>
                    <td colspan="3">
                      {{ formData.payRemark }}
                    </td>

                  </tr>

                  <tr>
                    <th>
                      单据时间段
                    </th>
                    <td>{{ formData.orderDates }}</td>


                    <th>
                      代理对象
                    </th>
                    <td v-if="formData.proxyObject==0">无代理</td>
                    <td v-else-if="formData.proxyObject==1">结算代理网点</td>
                    <td v-else-if="formData.proxyObject==2">被代理结算的网点</td>
                    <td v-else></td>

                    <th>
                      代理结算单
                    </th>
                    <td>
                      {{ formData.proxyNo }}
                    </td>


                  </tr>
                  </tbody>
                </table>
              </div>

              <div style="height:160px"></div>
            </div>

          </dix>
        </div>
      </el-form>
      <!-- 服务区域弹窗表 -->
    </div>


  </div>
</template>

<script>

import request from "@/router/axios";

import store from "@/store";
import api from "@/api/projectApi";
import {mapGetters} from "vuex";


export default {
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {},
  data() {
    return {
      formData: {
        settleNo: null,  // 结算单号:前缀"S"+年月日+6位流水号
        stat: 0,  // 状态：0未提交;1提交未审核;5审核待结算;9驳回;19已结算;99取消
        orgId: 0,  // 所属中心，关联脚手架机构表sys_dept.dept_id
        orgName: null,  // 所属机构名称,冗余字段
        orgIdPath: null,  // 所属机构ID路径,冗余字段.重要
        siteId: 0,  // 网点ID,关联sn_user.id;
        settleType: 0,  // 结算归类属性:1安装、2维修、29其他
        brandId: 0,  // 品牌ID,关联sn_company_brand.id
        brandName: null,  // 品牌名称,冗余字段;
        orderQty: 0,  // 工单数量
        machineQty: 0,  // 机器数量
        siteAmount: 0,  // 服务费
        rewardAmount: 0,  // 奖罚金额
        longDistanceAmount: 0,  // 远程费
        specialAmount: 0,  // 特设费用
        siteFinalAmount: 0,  // 业务总金额:以上金额+自定义费用项(sf_settle_fee_attribute.amount)之和
        adjustMount: 0,  // 本单调整金额：由调整金额操作给定
        adjustReason: null,  // 本单调整原因：由调整金额操作给定
        amount: 0,  // 总金额:业务总金额+本单调整金额
        taxRate: 0,  // 税率
        taxAmount: 0,  // 税额
        invoiceStat: 0,  // 发票状态：0未通知开票;1已通知开票;3网点已开票;5分公司已接收;7总部已接收;9已建结算批;98已驳回
        invoiceNoDate: null,  // 开票时间（由录发票号时指定）
        invoiceNo: null,  // 发票号（由录发票号时指定）
        invoiceNoAmount: 0,  // 发票金额（由录发票号时指定）
        payType: 0,  // 付款方式：1银行汇款;2转货款;3转配件款
        zhkAmount: 0,  // 转货款金额
        zpjAmount: 0,  // 转配件款金额
        qtAmount: 0,  // 其他金额
        realpayAmount: 0,  // 付现金额:由总金额-转货款金额-转配件款金额-其他金额得来
        bankName: null,  // 银行名称
        bankAccount: null,  // 银行帐号
        bankAccountName: null,  // 银行帐户
        checkDate: null,  // 审核时间
        payDate: null,  // 结算时间
        payRemark: null,  // 结算备注
        orderDates: null,  // 单据时间段
        proxyObject: 0,  // 代理对象：0无代理;1结算代理网点;2被代理结算的网点
        proxySettleId: 0,  // 代理结算单:关联sf_batch_settle.id

        siteName: null,
        proxyNo: null,
        sfBatchSettleOperationDTOList: null,
        sfSettleFeeAttributeDTOList: null
      },


      show3: false,

      srcList: [],

      showEdit: false,


      isEdit: false,
      dataId: '',

      showProductCategoryDialog: false,

    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId ? tenantId : '1'
      };
    }
  },
  created() {
    this.suspensionSettlement = this.permissions["suspensionSettlement"];
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    // console.log(this.tenant,"tenant的值");
  },
  mounted() {
    // this.initTableList();
    this.getData();
    console.log(this.tenant, "tenant的值");
    console.log(this.dataId, "_dataId7777的值");
  },
  methods: {
    cancelSettle(){
      this.$confirm('是否中止结算该工单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        try {
          this.loading = true;
          // 发送请求
          const res = axios.post(api.soApplyMoney.cancelSettle, {
            id:this._dataId
          });
          if (res.data) {
            this.$message.success('操作成功！');
            this.flushed()
          } else {
            this.$message.error('操作失败，请稍后重试');
          }
        } catch (error) {
          console.error(error);
          this.$message.error('系统错误，请稍后重试');
        } finally {
          this.loading = false;
        }
      })
    },

    handleClick(tab, event) {
      console.log(tab, event);
      console.log(tab.name, "name得值");
      if (tab.index == 0) {
        this.card = true
      } else {
        this.card = false
      }


    },


    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.sfBatchSettle.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data
          console.log(data,"data的值");
          if (!data.sfSettleFeeAttributeDTOList) {
            data.sfSettleFeeAttributeDTOList = []
          }
          if (!data.sfBatchSettleOperationDTOList) {
            data.sfBatchSettleOperationDTOList = []
          }
          this.formData = data
        })
      } else {
        this.enabled = true;
      }
    },


    // 第一个  表格
    formatter(row, column) {
      return row.isNeedReturn == 1 ? '是' : '否'
    },
    formatter1(row, column) {
      return row.isCheck == 1 ? '是' : '否'
    },
    formatter2(row, column) {
      return row.isPast == 1 ? '是' : '否'
    },
    formatter3(row, column) {
      if (row.afterFlow == 1) {
        return "必访"
      } else if (row.afterFlow == 2) {
        return '申诉'
      } else if (row.afterFlow == 3) {
        return '挂起'
      } else if (row.afterFlow == 4) {
        return '重新完工'
      } else if (row.afterFlow == 9) {
        return '关闭'
      }

    },
    // 卡片事件
    //点击查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // console.log(fileList, "已上传文件")
    },
    // 上传发生变化钩子
    // 注意 :on-remove="handleimageChange"与:on-change="handleimageChange" 都绑定这个方法，这样无论是上传图片还是移除图片，都会更新图片数据列表
    handleimageChange(file, fileList) {
      this.upload_img = fileList;
      // this.upload_img.imageName=fileList.name;
      console.log(fileList, "文件状态改变时")
      console.log(file, "文件状态改变时file")
    },
  },
};
</script>
<style lang="scss" scoped>
#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  > div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// 输入框的宽度
// #containt .table-detail tbody tr td .el-input {
//   width: 100% !important;
//   width: 0 !important;
// }

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover > td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  margin: 10px 0;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 1px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 380px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}

#containt .detail-wrap .d-cont {
  overflow: unset !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #00c4b3 !important;
}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}
// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #00c4b3;
  font-size: 13px;
}

::v-deep .el-image__preview {
  width: 60px !important;
  height: 60px !important;
}

.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: 20px 0 6px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 172.2px;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

#containt .table-detail tbody tr th {
  width: 6vw !important;
}

#containt .table-detail tbody tr td {
  width: 10vw !important;;
}

::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}
</style>
